import { Flex, Heading, Text } from '@chakra-ui/react';
import { memo } from 'react';

import { allCashTransactions, CashTransaction } from 'helpers/fakeData';

interface Props {
  currency: string;
}

const formatSigned = (transaction: CashTransaction): string => {
  const amount = transaction.amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sign = transaction.direction === 'in' ? '+' : '−';
  return `${sign}${amount} ${transaction.currency}`;
};

const TransactionHistory = ({ currency }: Props) => {
  const transactions = allCashTransactions.filter(
    (transaction) => transaction.currency === currency,
  );

  return (
    <Flex flexDirection="column" gap={4} h="full">
      <Heading as="h4" fontSize="md">
        Transaction History
      </Heading>
      {transactions.length === 0 ? (
        <Flex flexDirection="column" gap={2} alignItems="center" h="full" pt={10}>
          <Text color="text.secondary" fontSize="sm" fontWeight="semibold">
            No {currency} activity to display
          </Text>
        </Flex>
      ) : (
        <Flex flexDirection="column" gap={2}>
          {transactions.map((transaction) => (
            <Flex
              key={transaction.id}
              justifyContent="space-between"
              alignItems="center"
              bg="surface.muted"
              borderRadius="md"
              px={4}
              py={3}
            >
              <Flex direction="column">
                <Text fontSize="sm" fontWeight="medium">
                  {transaction.description}
                </Text>
                <Text fontSize="xs" color="text.secondary">
                  {transaction.date}
                </Text>
              </Flex>
              <Text
                fontSize="sm"
                fontWeight="semibold"
                color={transaction.direction === 'in' ? 'green.600' : 'text.primary'}
              >
                {formatSigned(transaction)}
              </Text>
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  );
};

export default memo(TransactionHistory);
